module.exports = __webpack_public_path__ + "img/EVRLogo - Lite.5080c8c8.png";